export default __webpack_public_path__ + "static/media/300-250.5de33a56.png";